"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _r10SourceLibrary = require("r10-source-library");

var _r10CommonComponents = require("r10-common-components");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactRouter = require("react-router");

var _jsonpath = _interopRequireDefault(require("jsonpath"));

var _Bucket = _interopRequireDefault(require("./Bucket"));

var _useConfig = _interopRequireDefault(require("../hooks/useConfig"));

var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));

var _selectors = require("../selectors");

var _actions = require("../actions");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var CardContent = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"])));

var Wrapper = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin: auto;\n  height: ", "px;\n  ", "\n  & .margin-auto {\n    margin: auto;\n  }\n"])), function (props) {
  return props.addExtraHeight ? 300 : 240;
}, _r10SourceLibrary.Mixins.respondTo.md((0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      height: ", "px;\n    "])), function (props) {
  return props.addExtraHeight ? 352 : 288;
})));

var App = function App() {
  var _config$CTAs7, _config$CTAs7$usageDe, _config$CTAs8, _config$CTAs8$renewBe;

  var config = (0, _useConfig.default)();
  var t = (0, _useTranslation.default)();
  var history = (0, _reactRouter.useHistory)();
  var isLoading = (0, _reactRedux.useSelector)(_selectors.isLoadingSelector);
  var hasError = (0, _reactRedux.useSelector)(_selectors.hasErrorSelector);
  var consumptionDetails = (0, _reactRedux.useSelector)(_selectors.consumptionDetailsSelector);
  var dispatch = (0, _reactRedux.useDispatch)();
  var productId = (0, _reactRedux.useSelector)(_selectors.getProductId);

  var fetchConsumptionDetails = function fetchConsumptionDetails() {
    dispatch((0, _actions.getConsumptionDetailsRequest)({
      baseUrl: config.baseUrl,
      productId: productId
    }));
  };

  (0, _react.useEffect)(function () {
    if (config) {
      fetchConsumptionDetails();
    }
  }, []);

  var renewBenefitsHandler = function renewBenefitsHandler() {
    var _config$CTAs, _config$CTAs$renewBen;

    history.push((_config$CTAs = config.CTAs) == null ? void 0 : (_config$CTAs$renewBen = _config$CTAs.renewBenefits) == null ? void 0 : _config$CTAs$renewBen.url);
  };

  var hasActiveBuckets = function hasActiveBuckets(consumDetails, statusPath) {
    return _jsonpath.default.query(consumDetails, statusPath.replace('{usageType}', config.buckets.map(function (b) {
      return b.usageType;
    }).join('|'))).includes('active');
  };

  var renderConsumptionCardContent = function renderConsumptionCardContent() {
    var _config$CTAs2, _config$CTAs2$renewBe, _config$CTAs3, _config$CTAs3$renewBe, _config$CTAs4, _config$CTAs4$renewBe, _config$CTAs5, _config$CTAs5$noConsu;

    return hasError ? /*#__PURE__*/_react.default.createElement(Wrapper, {
      addExtraHeight: (_config$CTAs2 = config.CTAs) == null ? void 0 : (_config$CTAs2$renewBe = _config$CTAs2.renewBenefits) == null ? void 0 : _config$CTAs2$renewBe.show
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      align: "center",
      justify: "center",
      disableFlex: true,
      className: "margin-auto"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
      col: "auto"
    }, /*#__PURE__*/_react.default.createElement(_r10CommonComponents.ErrorContent, {
      icon: "clock",
      title: t('timeOut'),
      description: t('timeoutErrorMessage'),
      buttonText: t('retryActionButtonText'),
      titleTestId: "consumption-card-timeout-title",
      descriptionTestId: "consumption-card-timeout-description",
      actionButtonTestId: "consumption-card-retryButton",
      iconSize: 1,
      buttonAction: fetchConsumptionDetails
    })))) : !!consumptionDetails && (hasActiveBuckets(consumptionDetails, config.BucketsJsonPaths.status) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "usage-bars"
    }, config.buckets.map(function (bucket) {
      return /*#__PURE__*/_react.default.createElement(_Bucket.default // Usual keys causes some problems with HorizontalBarChart translation,
      // as it didn't detect any changes
      , {
        key: Math.random(),
        bucket: bucket,
        consumptionDetails: consumptionDetails,
        BucketsJsonPaths: config.BucketsJsonPaths,
        unitsAliases: config.unitsAliases
      });
    })), ((_config$CTAs3 = config.CTAs) == null ? void 0 : (_config$CTAs3$renewBe = _config$CTAs3.renewBenefits) == null ? void 0 : _config$CTAs3$renewBe.show) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 4
      }
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
      width: "full",
      text: t('RENEW_BENEFITS'),
      onClick: renewBenefitsHandler,
      appearance: "secondary",
      dataAttributes: {
        'data-testid': 'renew-benefits-button'
      }
    }))) : /*#__PURE__*/_react.default.createElement(Wrapper, {
      addExtraHeight: (_config$CTAs4 = config.CTAs) == null ? void 0 : (_config$CTAs4$renewBe = _config$CTAs4.renewBenefits) == null ? void 0 : _config$CTAs4$renewBe.show
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
      align: "center",
      justify: "center",
      disableFlex: true,
      className: "margin-auto"
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
      col: "auto"
    }, /*#__PURE__*/_react.default.createElement(_r10CommonComponents.ErrorContent, _extends({
      icon: "add-ons",
      title: t('noAddonsTitle'),
      description: t('noAddonsDescription')
    }, ((_config$CTAs5 = config.CTAs) == null ? void 0 : (_config$CTAs5$noConsu = _config$CTAs5.noConsumption) == null ? void 0 : _config$CTAs5$noConsu.show) && {
      buttonText: t('noAddonsCTA')
    }, {
      titleTestId: "no-addons-title",
      descriptionTestId: "no-addons-description",
      actionButtonTestId: "no-addons-action-Button",
      iconSize: 1,
      buttonAction: function buttonAction() {
        var _config$CTAs6, _config$CTAs6$noConsu;

        return history.push((_config$CTAs6 = config.CTAs) == null ? void 0 : (_config$CTAs6$noConsu = _config$CTAs6.noConsumption) == null ? void 0 : _config$CTAs6$noConsu.url);
      }
    }))))));
  };

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    dataAttributes: {
      'data-testid': 'consumption-card'
    },
    elevation: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    noGutters: true,
    align: "center"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: "auto"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
    name: "chart-bar",
    group: "system",
    size: 4
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      left: 2
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 2,
    weight: 3,
    text: t('USAGE')
  }))), ((_config$CTAs7 = config.CTAs) == null ? void 0 : (_config$CTAs7$usageDe = _config$CTAs7.usageDetails) == null ? void 0 : _config$CTAs7$usageDe.show) && !isLoading && !hasError && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: "auto",
    autoMargin: "left"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SmallButton, {
    text: t('USAGE_DETAILS'),
    appearance: "alt1",
    onClick: function onClick() {
      alert('Not implemented yet');
    }
  }))), /*#__PURE__*/_react.default.createElement(CardContent, null, isLoading ? /*#__PURE__*/_react.default.createElement(Wrapper, {
    addExtraHeight: (_config$CTAs8 = config.CTAs) == null ? void 0 : (_config$CTAs8$renewBe = _config$CTAs8.renewBenefits) == null ? void 0 : _config$CTAs8$renewBe.show
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Loader, {
    dataAttributes: {
      'data-testid': 'consumption-card-loader'
    },
    text: t('loading'),
    size: 2,
    srText: "Loading"
  })) : !!config && renderConsumptionCardContent())));
};

var _default = App;
exports.default = _default;